"use client";

import {useCart} from "@/contexts/cartContext";
import {getShopConfig} from "@/server/shop/get-shop-config";

export default function HeaderCartButton(){
    const {cartCount,cartSummary, setSidecartOpen} = useCart();
    const nshop = getShopConfig();
    const { layout = 'classic' } = nshop.theme.header || {};
    switch(layout){
        case "minimal":{
            return (
                <button
                    type='button'
                    onClick={() =>
                        setSidecartOpen(true)
                    }
                    className='relative cursor-pointer flex items-center gap-2'
                    title={'Cart'}
                >
                    <svg aria-hidden="true" role="img" className="iconify iconify--streamline-ultimate" width="28"
                         height="28" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                           strokeWidth="1.5">
                            <path d="M19.049 6.75H4.936A1.4 1.4 0 0 0 3.5 7.907l-2 13.915a1.357 1.357 0 0 0 1.437 1.428h18.111a1.357 1.357 0 0 0 1.436-1.428l-2-13.915a1.4 1.4 0 0 0-1.435-1.157m-3.387-2.943A3.764 3.764 0 0 0 11.976.75A3.76 3.76 0 0 0 8.3 3.788"></path>
                            <path d="m14.653 13.5l-3.52 4.693l-2.141-2.14"></path>
                        </g>
                    </svg>
                    {cartCount > 0 && (
                        <span
                            className='absolute left-4 -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-red-700 text-xs text-white'
                        >
                    {cartCount}
                </span>
                    )}
                    <span className={'hidden lg:flex flex-col'}>
                        <span className={'text-xs opacity-70 font-medium'}>My Bag</span>
                        <span className={'text-sm'}>
                            £{cartSummary?.subtotal || '0.00'}
                        </span>
                    </span>
                </button>
            )
        }
        default:{
            return (
                <button
                    type='button'
                    onClick={() =>
                        setSidecartOpen(true)
                    }
                    className='relative cursor-pointer'
                    title={'Cart'}
                >
                    <svg aria-hidden="true" role="img" className="iconify iconify--streamline-ultimate" width="28"
                         height="28" viewBox="0 0 24 24">
                        <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                           strokeWidth="1.5">
                            <path d="M19.049 6.75H4.936A1.4 1.4 0 0 0 3.5 7.907l-2 13.915a1.357 1.357 0 0 0 1.437 1.428h18.111a1.357 1.357 0 0 0 1.436-1.428l-2-13.915a1.4 1.4 0 0 0-1.435-1.157m-3.387-2.943A3.764 3.764 0 0 0 11.976.75A3.76 3.76 0 0 0 8.3 3.788"></path>
                            <path d="m14.653 13.5l-3.52 4.693l-2.141-2.14"></path>
                        </g>
                    </svg>
                    {cartCount > 0 && (
                        <span className='absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-red-700 text-xs text-white'>
                            {cartCount}
                        </span>
                    )}
                </button>
            )
        }

    }

}